import {InputAdornment, TextField} from '@mui/material';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {BrickContext} from 'olympe';
import {requestStores} from '../../../../ListOfPREditors.brick.jsx';
import {createLabelValue} from '../../../../../utils/checkObjects';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import {useFieldEditability} from '../../../utils/useFieldEditability.js';

/**
 * @param {IncotermsDescription.propTypes} props
 * @return {Element}
 */
export const IncotermsDescription = (props) => {
    const MAX_LENGTH_DESC = 28;
    const useRequestStore = requestStores.get(props.prTag);
    const [incoterms, setIncoterms] = useRequestStore((state) => [state.incoterms, state.setIncoterms]);
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});

    const [inputValue, setInputValue] = useState(incoterms?.data?.label || '');
    const [editable, setEditable] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);

    // This useEffect keep the value of the Textfield updated when the incoterms is modified somewhere else
    useEffect(() => {
        setInputValue(incoterms?.data?.label || '');
    }, [incoterms]);

    const handleChange = (event) => {
        const value = event.target.value;

        if (value.length > MAX_LENGTH_DESC) {
            setInputValue(value.substring(0, MAX_LENGTH_DESC));
            setOpenTooltip(true);
        } else {
            setInputValue(value);
            setOpenTooltip(false);
        }
    };

    const handleBlur = (event) => {
        setIncoterms({data: createLabelValue(event.target.value, incoterms.data?.value), manuallyModified: true});
        setEditable(false);
    };

    const handleEdit = () => {
        setEditable(!editable);
    };

    return (
        <Tooltip
            title={`Too many characters. Only ${MAX_LENGTH_DESC} characters are allowed.`}
            open={openTooltip}
            placement={'top'}
            arrow >
            <TextField
                className={'pr-editor-header-details-incoterms-description'}
                variant={'standard'}
                value={inputValue ?? ''}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={!editable || props.loading || isDisabled('header.incotermsDescription')}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        <IconButton onClick={handleEdit} disabled={isDisabled('header.incotermsDescription')} edge="end">
                            <EditIcon/>
                        </IconButton>
                    </InputAdornment>,
                }}
            />
        </Tooltip>
    );
};

IncotermsDescription.propTypes = {
    context: PropTypes.instanceOf(BrickContext).isRequired,
    prTag: PropTypes.string.isRequired,
    loading: PropTypes.bool,
};
